export default [
    {
        path: '/privat/abonnement/oidcredirect',
        name: 'oidcredirect',
        beforeEnter: (to, from, next) => {
            // Guard in place to force vue to skip this page on inital load.
            next();
        },
        component: () => import('../views/OidcRedirect.vue'),
    },
    {
        path: '*',
        name: 'orderflow',
        component: () => import('../views/Orderflow.vue'),
    },
];
